/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { Link as RouterLink, useHistory,useNavigate } from 'react-router-dom';
import { Typography, Link } from '@material-ui/core';
import Axios from 'axios';
import CircularProgress from '@material-ui/core/CircularProgress';
import Backdrop from '@material-ui/core/Backdrop';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import Tooltip from '@material-ui/core/Tooltip'
import MuiAlert from '@material-ui/lab/Alert';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { AppBar, Toolbar, Badge, Hidden, IconButton } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import NotificationsIcon from '@material-ui/icons/NotificationsOutlined';
import { fakeAuth } from '../../../../views/authServices/privateRoute'
import ROUTE from '../../../../utils';
import InputIcon from '@material-ui/icons/Input';
import SettingsPowerIcon from '@material-ui/icons/SettingsPower';
import { colors } from '@material-ui/core';
import { LogoutBoolean } from '../../../../utils/index'
import {useLogout} from '../../../../utils/autoLogout'
import { Signature, Encryption } from '../../../../utils/index'

function Alert(props) {
  return <MuiAlert elevation={0} variant="filled" {...props} />;
}

const useStyles = makeStyles(theme => ({
  root: {
    boxShadow: 'none',
    backgroundColor: 'white',
  },
  flexGrow: {
    flexGrow: 1
  },
  appBarButton: {
    marginLeft: theme.spacing(1),
    color: colors.grey[900]
  },
  logout: {
    color: colors.grey[900],
    fontSize: 13
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

const Topbar = props => {
  const timer = useLogout(180); 
  /*Replacing useHistory() with useNavigate() thats support*/
  //let history = useHistory();
  const history = useNavigate();
  //navigate('/home');

  // if (timer < 5) {
  //   alert(`In ${timer} seconds you will be automatically logged out`)
  //   // return <div>In {timer} seconds you will be automatically logged out</div>;
  // }
  const { className, onSidebarOpen, ...rest } = props;
  const [openSnack, setOpenSnack] = useState(false);
  const [snackOpenError, setSnackOpenError] = useState(false);
  const [redirectToReferrer, setRedirectToReferrer] = useState(false)


  const classes = useStyles();

  const value = sessionStorage.getItem('token');
  const expTime = sessionStorage.getItem('exp');


  const [notifications] = useState([]);

  const logout = () => {
    return fakeAuth.signout(() => history(ROUTE.login));
  }

  const logoutConfig = {
    headers: {
      "signature": "b79a1fca7d05ba29bd619f745cbfc0365ed2c05b9d719614e59143024ecb2c89",
      "Content-Type": 'application/json;charset=UTF-8',
      "keep-alive": false,
    }
  };

  const handleLogout = async () => {
    handleToggleSnackBar();
    const number = localStorage.getItem("number")
    const value = { "id": number }

    // const apiUrl = "https://192.72.53.70/KYC/LogoutReveiw";
    
    const apiUrl = `${window.location.origin}/api/KYC/LogoutReveiw`;

    //const apiUrl = "http://10.129.2.15:9092/KYC/LogoutReveiw";
    //const apiUrl = "http://10.129.2.15:9092/KYC/LogoutReveiw";

    const objValues = {
      "username": "KYCUI-TEST",
      "applicationID": "KYCUI",
      "where": value,
      "action": "LOGOUT",
    }

    const hashedObjValues = Encryption(JSON.stringify(objValues));

    await Axios.post(apiUrl, hashedObjValues, logoutConfig).then(res => {
      if (res.data.response_message === "User logged out") {
        handleCloseSnackBar()
        fakeAuth.authenticate(() => {
          setRedirectToReferrer(false);
        })
        window.localStorage.clear();
        window.localStorage.removeItem('token');
        window.localStorage.removeItem('number');
        sessionStorage.clear();
        history(ROUTE.login)
        window.location.reload();
      } else {
        fakeAuth.authenticate(() => {
          setRedirectToReferrer(false);
        })
        history(ROUTE.login)
        window.localStorage.clear();
        window.localStorage.removeItem('token');
        window.localStorage.removeItem('number');
        handleCloseSnackBar()
        handleOpenSnackError()
      }
    })
      .catch(() => {
        window.localStorage.clear();
        window.localStorage.removeItem('token');
        window.localStorage.removeItem('number');
        history(ROUTE.login)
        handleCloseSnackBar()
        handleOpenSnackError();
      });
  }

  const handleOpenSnackError = () => {
    setSnackOpenError(true)
  }

  const handleCloseSnackError = (e, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackOpenError(false)
  }

  const handleCloseSnackBar = () => {
    setOpenSnack(false);
  };

  const handleToggleSnackBar = () => {
    setOpenSnack(true);
  };

  if(value){
    if (timer === 0) {
      handleLogout()
    }

  }

  return (
    <AppBar
      {...rest}
      className={clsx(classes.root, className)}
      position="fixed"
      color="inherit"
    >
      <Backdrop className={classes.backdrop} open={openSnack}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={snackOpenError}
        autoHideDuration={3000}
        onClose={handleCloseSnackError}
        key="topcenter"
        action={
          <React.Fragment>
            <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseSnackError}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      >
        <Alert onClose={handleCloseSnackError} severity="warning" className={classes.snackFont}>
          Unable to Login now, Please try again in a few minutes or contact support.
                    </Alert>
      </Snackbar>
      <Toolbar>

        <RouterLink to="/">
          <img
            alt="Logo"
            src="/images/logos/logo.jpeg"
            height={55}
          />
        </RouterLink>
        <div className={classes.flexGrow} />
        <Hidden >
          {/* <IconButton color="inherit">
            <Badge
              badgeContent={notifications.length}
              color="secondary"
              variant="dot"
            >
              <NotificationsIcon className={classes.appBarButton}/>
            </Badge>
          </IconButton> */}
          <Typography>Session Count Down &nbsp;:&nbsp;{timer}&nbsp;s</Typography>
          <Tooltip title="Logout" arrow placement="bottom">
          <IconButton
            className={classes.appBarButton}
            color="inherit"
            onClick={handleLogout}
          >
            <SettingsPowerIcon /><span className={classes.logout}>Logout</span>
          </IconButton>
          </Tooltip>
        </Hidden>
        <Hidden lgUp>
        <Tooltip title="View Menu" arrow placement="bottom">
          <IconButton
            color="inherit"
            onClick={onSidebarOpen}
          >
            <MenuIcon />
          </IconButton>
          </Tooltip>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
};

Topbar.propTypes = {
  className: PropTypes.string,
  onSidebarOpen: PropTypes.func
};

export default Topbar;
